import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountRadarResponse } from './types';

interface Props {
  data: AccountRadarResponse;
  compact?: boolean;
}

const AccountRadarView: React.FC<Props> = ({ data, compact = false }) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="bg-orange-50 dark:bg-orange-900/20 p-6 rounded-lg">
        <h2 className="text-2xl font-bold mb-2">Account Radar</h2>
        <p className="text-sm text-muted-foreground capitalize">{data.timeframe} view</p>
        <p className="mt-4 text-foreground">{data.summary}</p>
      </div>

      {data.items.length === 0 ? (
        <p className="text-muted-foreground">No accounts need immediate attention.</p>
      ) : (
        <div className="space-y-4">
          {data.items.map((item) => (
            <div
              key={item.customer_id}
              className="border border-border rounded-lg p-4 bg-card hover:shadow-sm transition-shadow"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <button
                    type="button"
                    onClick={() => navigate(`/customers/${item.customer_id}`)}
                    className="text-lg font-semibold text-primary hover:underline"
                  >
                    {item.customer_name}
                  </button>
                  {item.health_score != null && (
                    <p className="text-sm text-muted-foreground mt-1">Health: {item.health_score}/100</p>
                  )}
                  <p className="font-medium text-foreground mt-2">{item.attention_reason}</p>
                  {!compact && <p className="text-sm text-muted-foreground mt-1">{item.detail}</p>}
                  <p className="text-sm mt-2"><span className="font-medium">Evidence:</span> {item.evidence}</p>
                  <p className="text-sm mt-1 text-primary"><span className="font-medium">Action:</span> {item.recommended_action}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {!compact && (
        <p className="text-xs text-muted-foreground">
          Generated {new Date(data.generated_at).toLocaleString()}
        </p>
      )}
    </div>
  );
};

export default AccountRadarView;
